<template>
	<select @change='change' v-model="selected" class='form-control my-control table-control'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const ACT_INFO = 'get_act_info.php'
	const LPO_METHOD = 'get_lpo_method.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'lpoMethod',
		data: function () { 
			return {
				selected: '',
				options: []
			}
		},
		methods: {
			change () {
				EventBus.$emit(`edit_lpo_method`, this.selected)
			}
		},
		created: function () {
			fetch(DB + ACT_INFO + '?id=' + this.$route.params.id, {
				credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				return res[0].f_89
			})
			.then(id => {
				fetch(DB + LPO_METHOD, {
					credentials: 'include'
				})
				.then(data => data.json())
				.then(data => {
					if (data) {
						this.options = data
						this.selected = id ? id : data[0].id
						this.change()
					}
					else {
						this.options = []
					}
				})
				.catch(err => console.log(err))
			})
			.catch(err => console.log(err))
		}
	}
</script>


// WEBPACK FOOTER //
// lpoMethod.vue?05ba2871